class ProductGallery extends HTMLElement {
    constructor() {
        super();
        this.btnEventListeners();
        this.currentSlide = 1;
        this.updateArrows();
    }

    btnEventListeners() {
        const { arrowLeft, arrowRight, featuredImage } = this.galleryComponents();
        
        arrowLeft.addEventListener('click', () => {
            this.moveSlider(featuredImage.offsetWidth, 'left');
        })
        
        arrowRight.addEventListener('click', () => {
            this.moveSlider(featuredImage.offsetWidth, 'right');
        })
    }

    moveSlider(position, direction) {
        const { galleryGrid } = this.galleryComponents();
        let scrollPosition = galleryGrid.scrollLeft;

        galleryGrid.scrollTo({
            top: 100,
            left: direction == 'left' ?  scrollPosition - position : scrollPosition + position,
            behavior: "smooth",
        })

        //SOME TESTING HERE WOW

        if(direction == 'left') {
            this.currentSlide--;
        } else {
            this.currentSlide++;
        }

        this.updateArrows();
        this.updateCurrentActiveSlide(this.currentSlide);
    }

    updateArrows() {
        const { arrowLeft, arrowRight, galleryGrid } = this.galleryComponents();
        if(this.currentSlide == 1) {
            arrowLeft.classList.add('hidden');
            arrowRight.classList.remove('hidden');
            arrowLeft.parentElement.classList.replace('twcss-grid-cols-2', 'twcss-grid-cols-1');
        } else if (this.currentSlide == galleryGrid.childElementCount) {
            arrowRight.classList.add('hidden');
            arrowLeft.classList.remove('hidden');
            arrowLeft.parentElement.classList.replace('twcss-grid-cols-1', 'twcss-grid-cols-2');
        } else {
            arrowRight.classList.remove('hidden');
            arrowLeft.classList.remove('hidden');
            arrowLeft.parentElement.classList.replace('twcss-grid-cols-1', 'twcss-grid-cols-2');
        }
    }

    updateCurrentActiveSlide(currentSlideIndex) {
        this.querySelectorAll('.product-gallery-asset').forEach(asset => {
            asset.classList.remove('gallery-active-image');
        })
        this.querySelector(`#Slide-${currentSlideIndex}`).classList.add('gallery-active-image');
    }

    galleryComponents() {
        const arrowLeft = this.querySelector('.controls-arrow-left');
        const arrowRight = this.querySelector('.controls-arrow-right');
        const featuredImage = this.querySelector('.gallery-featured-image');
        const galleryGrid = this.querySelector('#product-gallery-grid');

        return { arrowLeft, arrowRight, featuredImage, galleryGrid }
    }
}

customElements.define("product-gallery", ProductGallery);
